module.exports = __webpack_public_path__ + "static/media/view_.7a88c50a.svg";